import { Badge } from "@/components/ui/badge";

interface PrescriptionTagsProps {
  tags?: string[] | null;
}

export function PrescriptionTags({ tags }: PrescriptionTagsProps) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {tags.map((tag, index) => (
        <Badge key={index} variant="outline" className="text-xs">
          {tag}
        </Badge>
      ))}
    </div>
  );
}
